export class noteEditor {
  constructor(difference) {
    this.width = 300
    this.height = 100
    this.top = 0
    this.left = 0
    this.innerElement = "cxNoteEditor"
    this.content = "<p>请输入文本内容</p>"
    this.bgColor = "rgba(255,255,255,0)"
    this.rotate = 0
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.borderIsThemeColor = false
    this.textOverFlowType = "visible"
    // 透明度
    this.opacity = 100
    // 阴影
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.background = []
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
